const customerInsightPropensityPageData = {
  slug: "customer-insight-and-propensity",
  title: "Customer Insight & Propensity",
  introduction:
    "Actionable intelligence, insights and predicting customer behaviour — powered by leading information technologies and data.",
  hero: {
    eyebrow: "Analytics & Modelling",
    align: "left",
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "clv",
      variant: "feature",
      icon: "insights",
      title: "Customer Lifetime Value Chain",
      content: [
        "We help businesses focus on creating customer value — making marketing decisions based on how much value a customer brings to your business.",
        "Our in-depth and powerful customer lifetime value prediction models help identify your most valuable and profitable customers, enabling you to understand the real long-term customer value, optimise your profit gain, and to better inform your decision-making.",
        "This provides you with intelligent, granular information, giving you an appreciation of the long-term impact to your business objectives.",
      ],
    },

    {
      type: "benefits",
      variant: "pillars",
      heading: "Propensity Models",
      titleDivider: true,
      items: [
        {
          icon: "insights",
          title: "Customer Segmentation",
          description:
            "Identify the customers and their lifecycle activities for prioritisation and messaging with enhanced targeting and segmentation.",
        },
        {
          icon: "warning",
          title: "Drop-off Propensity",
          description:
            "Predict a customer's duration based on their lifecycle attributes and understand their propensity to churn and drop off.",
        },
        {
          icon: "dollar",
          title: "Customer Investment",
          description:
            "Understand the true cost of acquiring and retaining customers at individual and aggregated levels.",
        },
      ],
    },

    {
      type: "barChart",
      heading: "Illustrative Customer Value Distribution",
      items: [
        { label: "High Value", value: 82, tag: "High ROI", color: "#db0058" },
        { label: "Growing Value", value: 61, tag: "Nurture", color: "#e8639d" },
        { label: "At Risk", value: 40, tag: "Intervene", color: "#a8134a" },
        { label: "Lapsed", value: 22, tag: "Re-engage", color: "#f3b8d1" },
      ],
    },

    {
      id: "granular-insight",
      group: "granular",
      title: "Providing Insight in a Granular Way",
      content: [
        "Maximising your ability to scale profitably and to fully consider the economic value of customers. Our services provide detailed measurement of your individual customer segments value, enabling you to make accurate operational and strategic long-term decisions to improve the return on investment.",
      ],
    },
    {
      id: "continuous-review",
      group: "granular",
      title: "Continuous Performance Review",
      content: [
        "Customer dimensional segments are regularly reviewed to identify key value indicators and areas of low performance and intervene early to gain performance improvement.",
      ],
    },

    {
      type: "benefits",
      variant: "outcomes",
      heading: "Key Benefits",
      titleDivider: true,
      items: [
        {
          title: "Increased ROI",
          description:
            "Optimise your profit gain by focusing on your most valuable and profitable customers.",
        },
        {
          title: "Smarter Targeting",
          description:
            "Enhanced targeting and segmentation enables prioritisation and messaging across your customer base.",
        },
        {
          title: "Strategic Decisions",
          description:
            "Intelligent, granular information supports accurate operational and long-term strategic decision-making.",
        },
        {
          title: "Churn Prevention",
          description:
            "Understand each customer's propensity to churn and drop off, so you can intervene early.",
        },
      ],
    },

    {
      id: "cta-highlight",
      variant: "feature",
      icon: "insights",
      title: "Unlock the True Value of Your Customer Data",
      content: [
        "Talk to our team about Customer Insight & Propensity modelling for your business.",
      ],
      cta: { label: "Speak to an expert", href: "#enquiry" },
    },
  ],

  // No fixed pricing model exists for this service.
  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "Customer Insight & Propensity",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "Customer Insight & Propensity - Lloyd James Data Consultancy",
    description:
      "Predict customer behaviour with Customer Insight & Propensity modelling — lifetime value, segmentation, drop-off propensity and investment analysis in one service.",
    keywords:
      "customer insight, customer propensity, customer lifetime value, customer segmentation, drop-off propensity, churn prediction, customer investment, Lloyd James",
    canonical: "/customer-insight-and-propensity/",
  },
};

export default customerInsightPropensityPageData;
